<template>

  <Form :model="form" label-position="top">
    <p slot="header" style="color:#f60;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Delete confirmation</span>
        </p>
    <FormItem label="Name">
      <Input v-model="form.name" placeholder=""></Input>
    </FormItem>
    <FormItem label="Location">
      <Input v-model="form.location" placeholder=""></Input>
    </FormItem>
    <FormItem label="Question">
      <Input type="textarea" :rows="3" v-model="form.q" placeholder=""></Input>
    </FormItem>
    <!--
    <FormItem>
      <Button type="primary" @click="saveClick()" style="float:right;" v-if="!isSaving">Send</Button>
      <Button type="primary" style="float:right;" disable v-if="isSaving">Please wait</Button>
    </FormItem>
    -->
    <div slot="footer">
            <Button type="error" size="large" long >Delete</Button>
        </div>
  </Form>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      isSaving: false
    }
  }
}
</script>

<style>

</style>
